import { getActiveChainId, setActiveChainId } from '@/utils'
import { FC, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { AppState } from '..'
import { useAppSelector } from '../hooks'
import { useSwitchChain } from './hooks'
import { ENV_CONFIG } from '@/constants/envs/constants'
import { ChainId } from '@/lib/chain'

export const SellCryptoChainUpdater: FC = () => {
  const dispatch = useDispatch()
  const switchChain = useSwitchChain()
  const currentChainId = useAppSelector(
    (appState: AppState) => appState.sellCrypto.chainId
  )

  // On mount: sync chainId from localStorage into Redux state
  // This ensures the correct chain is loaded when navigating via SwapDirectionButton
  useEffect(() => {
    try {
      const storedChainId = getActiveChainId()
      if (storedChainId) {
        const storedChainIdNum = Number(storedChainId) as ChainId
        if (
          ENV_CONFIG.supportedChains.includes(storedChainIdNum) &&
          storedChainIdNum !== currentChainId
        ) {
          switchChain(storedChainIdNum)
        }
      }
    } catch (error) {
      console.error(error)
    }
    // eslint-disable-next-line
  }, [])

  // Write current chainId to localStorage whenever it changes
  useEffect(() => {
    try {
      setActiveChainId(currentChainId)
    } catch (error) {
      console.error(error)
    }
  }, [dispatch, currentChainId])

  return null
}
